<template>
  <div class="flex-col justify-start relative page">
    <div class="flex-col justify-start items-center">
      <img class="image_1" :src="computedPicture('bg3')" />
    </div>
    <div class="sujm">
      <div class="header">
        <!-- <div class="heatop">
          <div class="logo" @click="back">
            <img src="@/assets/logo.png" alt="">
          </div>
        </div> -->
        <div class="Toggle Togglebackg" :class="motif == 4 ? 'Togglebackg4' : ''">
          <div class="Toggle_l">
            <div class="logo" @click="back">
              <img src="@/assets/logo.png" alt="">
            </div>
          </div>
          <div class="Toggle_r">
            <div class="settime">
              <el-select v-model="value" placeholder="请选择" @change="change" class="sele">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <div class="settimem">
                <img src="@/assets/imglv1/settime.png" alt="">
              </div>
            </div>
            <div class="xiaci" v-if="timeArray.length > 0">{{ timewz }}</div>

          </div>
        </div>
      </div>
      <div class="content">
        <div class="flex-col section_2 pos">
          <!-- <img src="@/assets/imglv1/wz1.png" alt="" class="section_2-title" /> -->
          <div class="bigtit" :class="motif == 3 ? 'color3' : ''">生平简介</div>
          <span class="text_3" :class="motif == 3 ? 'color3' : ''">
            {{ jianli }}
          </span>
        </div>
        <div class="flex-col justify-start section_3 pos_2">
          <div class="pos_motif3" v-if="motif == 3">
            <video class="imgaemotif3 image" controls loop :poster="details.image" v-if="details.video_url1" >
              <source :src="details.video_url1" :key="details.video_url1" />
            </video>
            <div class="Nodataimg imgaemotif3" v-else>
              <img class="" src="@/assets/imglv1/Nodataimg.png" />
              <div class="wz">暂无内容</div>
            </div>
          </div>
          <div class="pos_5" v-else>
            <video class="image" controls loop :poster="details.image" v-if="details.video_url1">
              <source :src="details.video_url1" :key="details.video_url1" />
            </video>
            <div class="Nodataimg image" v-else>
              <img class="" src="@/assets/imglv1/Nodataimg.png" />
              <div class="wz">暂无内容</div>
            </div>
          </div>

          <div class="erweimbto">
            <div class="danmu">
              <!--插件地址  https://www.npmjs.com/package/vue-danmaku -->
              <vue-danmaku v-if="danmushow" v-model="list" useSlot style="height:100%; width:100%;" :speeds="100"
                :autoplay="false" ref="danmaku" randomChannel :debounce="500" @list-end="listend" @play-end="playend"
                :channels="2">
                <!-- 弹幕插槽（vue 2.6.0 及以上版本可使用 v-slot:dm="{ index, danmu }"语法） -->
                <template slot="dm" slot-scope="{ index, danmu }">
                  <div class="list">
                    <div class="wz wzbg" :class="motif == 4 ? 'wzbg4' : ''" v-show="danmu.type == 1">
                      <div class="h_center">
                        <div class="h_center">
                          <div>{{ danmu.nickname }}</div>
                          <div>送了一朵{{ danmu.oblation_name }}</div>
                        </div>
                        <img :src="danmu.image" alt="">
                      </div>
                    </div>
                    <div class="wz wzbg" :class="motif == 4 ? 'wzbg4' : ''" v-show="danmu.type == 2">
                      <div class="h_center">
                        <div class="h_center">
                          <div>{{ danmu.nickname }}</div>
                          <div>上了一炷{{ danmu.oblation_name }}</div>
                        </div>
                        <img :src="danmu.image" alt="">
                      </div>
                    </div>
                    <div class="wz wzbg" :class="motif == 4 ? 'wzbg4' : ''" v-show="danmu.type == 3">
                      <div class="h_center">
                        <div>{{ danmu.nickname }}说:{{ danmu.content }}</div>
                        <div style="height: 40px;"></div>
                      </div>
                    </div>
                  </div>

                </template>
                <!-- 容器插槽 -->
              </vue-danmaku>
            </div>


            <div class="ewm-bt" :class="{ ewmCenter: !hasTools }">
              <img :src="ewm" alt="" class="ewm" />
              <div>
                <img src="@/assets/imglv1/smsx2.png" alt="" class="ewm-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="weixin-pop" id="weixinPop">
      <img class="img" src="@/assets/imglv1/weixin-pop.ccf34458.png" alt="">
    </div>
  </div>
</template>
<script>
import { getLiuyan, detileGet, stickPost, getList } from "@/api/go";
import QRCode from "qrcode";
import vueDanmaku from 'vue-danmaku'
export default {
  components: {
    vueDanmaku
  },
  beforeRouteEnter(to, from, next) {
    let s = to.query.s;
    if (s) {
      if (s == 1) {
        next();
      } else if (s == 2) {
        next({
          name: "farewell",
          query: to.query
        });
      } else if (s == 3) {
        next({
          name: "VideoAnimation",
          query: to.query
        });
      }
    } else {
      next();
    }
  },
  data() {
    return {
      id: "",
      list: [],
      page: 1,
      ewm: "",
      hasTools: !this.$route.query.s,
      danmushow: true,
      motif: 1,
      options: [{
        value: '1',
        label: '整点上香'
      }, {
        value: '2',
        label: '每2小时上香'
      }, {
        value: '3',
        label: '每3小时上香'
      }, {
        value: '0',
        label: '取消上香'
      }],
      value: '',
      timer: null,
      timeArray: [],
      timewz: '',
      details: ''
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.motif = localStorage.getItem('motif') || 1

    // 当前是否是移动微信浏览器 微信官方js判断做法
    const userAgent = navigator.userAgent;
    const isWeixin = /MicroMessenger/i.test(userAgent) && /Mobile/i.test(userAgent);
    if (isWeixin) {
      var weixinPop = document.getElementById('weixinPop');
      weixinPop.style.display = 'block';
    }

    this.detileData()
  },
  computed: {
    jianli() {
      return this.details.biography;
    },
    fontSize() {
      let text = this.jianli || "";
      let xx = (text.match(/[0-9a-zA-Z]/gim) || []).length;
      let size = 60 / (text.length - xx * 0.5);
      if (size > 0.18) {
        size = 0.18;
      }
      return size + "rem";
    }
  },
  watch: {
    // "$route.query.id": {
    //   handler(val) {
    //     if (val) {
    //       this.init();
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    computedPicture(url) {
      var imgurl = `https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imglv1/theme${this.motif}/${url}.png`
      return imgurl
    },
    handleCommand(ty) {
      this.motif = ty
      localStorage.setItem('motif', ty);
    },
    // init() {
    //   this.id = this.$route.query.id;
    //   this.$store.dispatch("getUserInfo", { id: this.id }).then(() => {
    //     this.initDanmu(true);
    //   });
    //   this.getEWM();
    //   this.$nextTick(() => {
    //     this.$refs.danmaku.play()
    //   });

    // },
    async initDanmu(ty) {
      this.getLiuyan(ty);
      this.startDanmu();
    },
    listend() {
      // 所有弹幕插入完毕
      // this.initDanmu();
      console.log('所有弹幕插入完毕')
    },
    playend() {
      console.log('所有弹幕播放完成')
      let that = this
      //当前使用的弹幕组件会有内存泄漏问题  播放完一轮后停止播放并卸载 10秒后再加载
      setTimeout(() => {
        that.danmushow = false
      }, 200);
      // console.log(this.list)

      this.timer3 = setTimeout(() => {
        that.danmushow = true
        this.page = 1
        this.list = []
        this.getLiuyan()
        // that.$nextTick(() => {
        //   that.$refs.danmaku.play()
        // });
      }, 1000 * 3);
    },
    getLiuyan() {
      let that = this
      let array1 = this.list
      let array2

      getList({
        userId: Number(this.id),
        page: this.page,
        limit: 20,
        device: 'pc'
      }).then(res => {

        array2 = res.data


        // 提取 array2 中 id 不在 array1 中的对象
        let uniqueInArray2 = array2.filter(item2 =>
          !array1.some(item1 => item1.id === item2.id)
        );
        this.list = this.list.concat(uniqueInArray2)



        // that.$refs.danmaku.push(uniqueInArray2[i])


        // if (array1.length == 0) {
        //   this.list = this.list.concat(uniqueInArray2)
        //   // this.$nextTick(() => {
        //   //   that.$refs.danmaku.play()
        //   // });
        // } else {
        //   for (let i = 0; i < uniqueInArray2.length; i++) {
        //     that.$refs.danmaku.push(uniqueInArray2[i])
        //   }
        // }

        if (res.totalPage <= this.page || res.totalPage == 0) {

          this.$nextTick(() => {
            that.$refs.danmaku.play()
          });
        } else {
          if (this.page < res.totalPage) {
            setTimeout(() => {
              that.getLiuyan()
            }, 100);

          }

        }
        this.page++;

      }).catch(err => {
        console.log(err, '链接错误')
        // 确保断网重连
        setTimeout(() => {
          this.getLiuyan()
        }, 1000 * 3);
      });
    },
    // 获取信息
    detileData() {
      detileGet({
        userId: Number(this.id)
      }).then(res => {
        console.log(res)
        if (res.auth_config) {
          this.details = res
          this.initDanmu(true);
          this.value = res.stick_type
          this.timeArray = res.stick_list
          if (res.stick_list.length > 0) {
            this.sticklist(res.stick_list)
          } else {
            if (this.timer) {
              clearInterval(this.timer);
              this.timer = null;
            }
          }

          this.getEWM();
          // this.$nextTick(() => {
          //   this.$refs.danmaku.play()
          // });
        }


      }).catch(err => {

      });
    },
    // 设置
    change(e) {
      stickPost({
        id: Number(this.id),
        type: e
      }).then(res => {
        this.detileData()
      }).catch(err => {

      });
    },
    // 跳转
    sticklist(timeArray) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      // 每秒钟检查一次时间
      this.timer = setInterval(() => {
        this.checkCurrentTime(timeArray)
      }, 1000);
    },
    checkCurrentTime(timeArray) {
      // checkCurrentTime() {
      // var timeArray=['15:05:00','15:06:00','15:07:00','15:08:00','15:09:00']
      const now = new Date();
      this.currentTime = now.getHours() + ':' + String(now.getMinutes()).padStart(2, '0') + ':' + String(now.getSeconds()).padStart(2, '0');
      if (!timeArray) {
        return
      }
      this.isInTimeRange = timeArray.includes(this.currentTime);

      if (this.isInTimeRange) {
        console.log('当前时间在指定的时间段内:', this.currentTime);
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.$router.replace({
          name: "mourning",
          query: {
            id: this.id
          }
        });
      } else {
        console.log('当前时间不在指定的时间段内:', this.currentTime);
        this.timewz = this.timeRemaining()
      }
    },
    // 计算即将到来的时间
    timeRemaining() {
      let currentTime = this.currentTime
      let timeArray = this.timeArray
      if (!currentTime || !timeArray) {
        return
      }
      // 解析当前时间
      const [currentHours, currentMinutes, currentSeconds] = currentTime.split(':').map(Number);
      const currentDate = new Date();
      currentDate.setHours(currentHours, currentMinutes, currentSeconds, 0);

      // 存储最近的时间
      let nearestTime = null;
      let minDiff = Infinity;

      timeArray.forEach(time => {
        const [hours, minutes] = time.split(':').map(Number);
        const recordDate = new Date();
        recordDate.setHours(hours, minutes, 0, 0);

        // 计算时间差（以毫秒为单位）
        const diff = recordDate - currentDate;

        // 只考虑未来的时间（diff > 0）
        if (diff > 0 && diff < minDiff) {
          minDiff = diff;
          nearestTime = recordDate;
        }
      });

      // 如果找到最近的时间
      if (nearestTime) {
        const totalMinutes = Math.floor(minDiff / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0) {
          return `距离下次上香还有${hours}小时${minutes}分钟`;
        } else {
          return `距离下次上香还有${minutes}分钟`;
        }
      } else {
        return '';
      }
    },
    startDanmu() {
      let time = 1;
      // this.startDanmuTimer = setTimeout(() => {
      //   let textObj = this.list.shift() || {};
      //   this.initDanmu();
      // }, time * 4000);
    },
    getRandomIntInclusive(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; // 包含min和max
    },
    back() {
      this.$router.replace({
        name: "list",
        query: {
          id: this.id
        }
      });
    },
    toIndex() {
      this.$router.replace({
        name: "index",
        query: {
          id: this.id
        }
      });
    },
    toFarewell() {
      this.$router.replace({
        name: "farewell",
        query: {
          id: this.id
        }
      });
    },
    toAudio() {
      this.$router.push({
        name: "audio",
        query: {
          id: this.id
        }
      });
    },
    toVideo() {
      this.$router.push({
        name: "VideoAnimation",
        query: {
          id: this.id
        }
      });
    },
    getEWM() {
      // console.log(location.origin + `/mobilelt?id=${this.id}&ty=1&SweetShow=${this.details.belief}`)
      QRCode.toDataURL(
        location.origin + `/mobilelt?id=${this.id}&ty=1&SweetShow=${this.details.belief}`
      )
        .then(url => {
          this.ewm = url;
        })
        .catch(err => {
          console.error(err);
        });
    },
    tourl(ty) {
      if (ty == 0) {
        this.$router.replace({
          name: "index",
          query: {
            id: this.id
          }
        });
      } else if (ty == 1) {
        this.$router.replace({
          name: "farewell",
          query: {
            id: this.id
          }
        });
      } else if (ty == 2) {
        this.$router.replace({
          name: "VideoAnimation",
          query: {
            id: this.id
          }
        });
      }

    },
  },
  beforeDestroy() {
    this.$refs.danmaku.stop()
    if (this.startDanmuTimer) {
      clearTimeout(this.startDanmuTimer);
      this.startDanmuTimer = null
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null
    }
  }
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;

  .image_1 {
    width: 100vw;
    height: 100vh;
  }

  .sujm {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .section_2 {
    position: relative;
    overflow: hidden;
    width: 660px;
    background-size: 100% 100%;
    margin-right: 60px;

    .section_2-title {
      width: 260px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0px;
    }

    .group {
      width: 489px;

      .text_2 {
        color: #a5e1e1;
        font-size: 16px;
        color: #a5e1e1;
        line-height: 32.68px;
        text-align: justify;
        font-family: 思源黑体;
      }
    }

    .text_3 {
      font-size: 30px;
      font-family: "Source Han Sans CN";
      line-height: 43px;
      text-align: justify;
      color: #fff;
      // height: 600px;
      // font-weight: bold;
      height: 700px;
      overflow: auto;
      // padding: 0px 20px 0 20px;
    }

    .text_3::-webkit-scrollbar {
      display: none;
    }

    .color1 {
      color: #A5E1E1;
    }

    .color2 {
      color: #FFFFFF;
    }

    .color3 {
      color: #A5E1E1;
    }

    .color4 {
      color: #FFFFFF;
    }

    .color5 {
      color: #a5e1e1;
    }

    .color6 {
      color: #FFFFFF;
    }
  }

  .ewm {
    width: 170px;
    height: 170px;
    border-radius: 8px;
  }

  .ewm-icon {
    margin: auto;
    width: 170px;
    margin-top: 20px;
  }


  .erweimbto {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;

    .danmu {
      width: 850px;
      height: 200px;

      .list {
        margin-bottom: 32px;
        font-size: 28px;
        color: #000000;

        .wz {
          padding: 10px 14px;
          border-radius: 50px;
          display: inline-block;
          line-height: 50px;
          color: #fff;

          img {
            height: 40px;
            margin-left: 10px;
          }
        }

        .wzbg {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }


  .ewmCenter {
    right: calc(30%);
  }

  .content {
    // position: fixed;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    // align-items: center;
  }

  .section_3 {
    position: relative;

    // padding-top: 120px;
    .section_3-title {
      position: absolute;
      width: 231px;
      top: -80px;
      left: 50%;
      transform: translateX(-50%);
    }

    .pos_3 {
      width: 13.41%;
      position: absolute;
      left: 50%;
      top: 0px;
      transform: translateX(-50%);
    }

    .image {
      width: 1000px;
      height: 562.5px;
      object-fit: cover;
      // object-fit: contain;
    }

    .image_2 {
      width: 92px;
      height: 93px;
    }

    .pos_6 {
      position: absolute;
      right: 53px;
      bottom: 58.5px;
    }

    .imgaemotif3 {
      position: absolute;
      bottom: 20px;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
      width: 1000px;
      height: 520px;
    }

    .pos_motif3 {
      position: relative;
      overflow: hidden;
      width: 1040px;
      height: 600px;
      background: url('~@/assets/imglv1/theme3/videobg1.png');
      background-size: 100% 100%;
    }

    .pos_5 {
      position: relative;
      overflow: hidden;
      // padding: 20px;
      // background: #FFFFFF;
      border: 20px solid #fff;
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .Nodataimg {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 589px;
        height: 348px;
      }

      .wz {
        font-size: 36px;
        color: #fff;
        font-weight: bold;
        margin-top: 20px;
      }
    }

    .bg5 {
      background: #292c35 !important;
    }
  }

  .font {
    font-size: 35px;
    font-family: "Source Han Sans CN";
    line-height: 34px;
    font-weight: 700;
  }
}

.group-right {
  margin-top: 36px;
  text-align: center;

  .button {
    padding: 16px 22px 15px 26px;
    border-radius: 33px;
    // background: rgba(10, 26, 52, 0.4);
    // border: 1.65px solid rgba(89, 175, 249, 0.7049);
    // box-shadow: inset 0px 0px 8.25px 0.5px rgba(3, 251, 255, 0.6513);
    // color: #01c2ff;
    cursor: pointer;
    width: max-content;

    &+.button {
      margin-left: 90px;
    }

    img {
      width: 34px;
      margin-right: 8px;
    }

    .tools-button {
      font-size: 26px;
      font-family: 思源黑体;
      line-height: 33px;
      font-weight: 700;
    }
  }
}

.po-r {
  position: relative;
}
</style>
<style lang="less">
@keyframes moveRight {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }

  to {
    transform: translateX(0%);
    opacity: 1;
  }
}

.danmu-item {
  // position: absolute;
  animation: moveRight 0.5s linear;
  z-index: 999;
  color: #fff;
  border-radius: 8px;
  text-shadow: #000 0px 0px 2px;
  font-size: 26px;
  line-height: 46px;
  font-weight: bold;
  // display: flex;
  width: 100%;
  backdrop-filter: blur(2px);

  div:last-child {
    flex: 1;
  }

  &+.danmu-item {
    // margin-top: 14px;
  }
}

// .header{
//   position: fixed;
//     top: 0;
//     right: 0;
//     left: 0;
//     .heatop{
//         padding-top: 46px;
//         padding-right: 50px;
//         padding-left: 100px;
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         .back{
//            img{
//             width: 38px;
//             height: 40px;
//            }
//         }

//         .settime{
//           position: relative;
//           width: 80px;
//           height: 80px;
//           .settimem{
//             position: absolute;
//             top: 50%;
//             left: 50%;
//             z-index: 10;
//             transform: translate(-50%, -50%);
//             text-align: center;
//             font-size: 18px;
//             color: #fff;
//             font-weight: bold;
//             img{
//               width: 80px;
//               height: 80px;
//             }
//           }

//           .sele{
//             position: absolute;
//             top: 0;
//             left: 0;
//             width: 80px;
//             height: 80px;
//             z-index: 20;
//             opacity: 0;
//           }
//         }
//     }
// }
.header {
  .heatop {
    padding-top: 20px;
    padding-right: 50px;
    padding-left: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 35px;

    .logo {
      color: #fff;
      font-weight: bold;
      cursor: pointer;

      img {
        height: 40px;
      }
    }

    .xiaci {
      color: #fff;
      font-weight: bold;
      transform: skewX(-8deg);
    }
  }

  .Togglebackg {
    background: rgba(33, 33, 33, .5);
  }

  .Toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    margin-top: 50px;

    .Toggle_l {
      padding-left: 40px;
      display: flex;
      align-items: center;

      .logo {
        color: #fff;
        font-weight: bold;
        cursor: pointer;

        img {
          height: 40px;
        }
      }
    }

    .Toggle_r {
      padding-right: 60px;
      display: flex;
      align-items: center;
      height: 80px;

      .el-dropdown-link {
        display: flex;
        align-items: center;
        font-size: 34px;
        color: #FFFFFF;
        font-weight: 500;

        img {
          width: 50px;
          // height: 30px;
        }
      }

      .settime {
        position: relative;
        width: 80px;
        height: 80px;

        .settimem {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 10;
          transform: translate(-50%, -50%);
          text-align: center;
          font-size: 18px;
          color: #fff;
          font-weight: bold;

          img {
            width: 50px;
            height: 50px;
            margin-left: 20px;
          }
        }

        .sele {
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 80px;
          z-index: 20;
          opacity: 0;
        }
      }

      .xiaci {
        color: #fff;
        font-weight: bold;
        transform: skewX(-8deg);
        font-size: 30px;
      }
    }
  }
}

.bigtit {
  text-align: center;
  font-size: 65px;
  font-weight: bold;
  transform: skewX(-5deg);
  color: #fff;
  padding: 30px 0;
  letter-spacing: 4px;
}

.opc {
  opacity: 0;
}

/deep/ .el-select-dropdown {
  top: 80px !important;
}

.h_center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Togglebackg4 {
  background: #F6AB87 !important;
}

.wzbg4 {
  background: #FF9672 !important;
}
</style>
